import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getCapitolKeys } from '@/services/keys/get-capitol-keys';
import { Key } from '@/types';
import { useOrgStore } from '@/stores/org-store';

export const useGetCapitolKeys = (
  options?: Omit<UseQueryOptions<Key[], Error, Key[]>, 'queryKey' | 'queryFn'>,
) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<Key[], Error>({
    queryKey: ['capitol-keys', orgId],
    queryFn: getCapitolKeys,
    enabled: !!orgId,
    ...options,
  });
};
